import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=08066792&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=08066792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08066792",
  null
  
)

export default component.exports